import Box from "@mui/material/Box";
import {
  Autocomplete,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch } from "../../../app/hooks";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import { getCategoryData } from "../../../features/category/categorySlice";
import { getManufacturerData } from "../../../features/manufacturer/manufacturerSlice";
import {
  getNonMedicalData,
  registerMedical,
} from "../../../features/nonMedical/nonMedicalSlice";
import {
  AddMedicine,
  getAllMedicineData,
} from "../../../features/medicine/medicineSlice";
import { units } from "../../../utils/constants";
const BarcodeReader = require("react-barcode-reader").default;

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  setOpenErrorToast?: any;
  getMedical: () => void;
  setErrorMessage?: any;
  setMedicineId?: any;
  getMedicine?: any;
}
const AddNonMedicalModal = ({
  handleClose,
  setOpenSnackbar,
  getMedical,
  setOpenErrorToast,
  setErrorMessage,
  setMedicineId,
  getMedicine
}: IProps) => {
  const dispatch = useAppDispatch();

  const [categoryData, setCategoryData] = useState<any>(null);
  const [manufacturerNameData, setManufacturerNameData] = useState<any>(null);
  const [categoryId, setCategoryId] = useState<any>(null);
  const [manufacturerId, setManufacturerId] = useState<any>(null);
  const [categoryError, setCategoryError] = useState("");
  const [medNameError, setMedNameError] = useState("");
  const [manufacturerError, setManufacturerError] = useState("");
  const [apiError, setApiError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [medicineName, setMedicineName] = useState<any>("");
  const [weightValue, setWeightVale] = useState({
    textField: "",
    selectField: "",
  });

  const [medBarcode, setMedBarcode] = useState("");

  const handleScan = (data: any) => {
    if (data) {
      if (data === medBarcode) return;
      setMedBarcode(data);
    }
  };

  const handleBarChange = (e: any) => {
    let value = e?.target?.value.trim();
    if (value.length <= 13) {
      setMedBarcode(value);
    }
  };

  const handleError = (err: any) => {
    console.error(err);
  };

  const handleMedicineName = (event: any) => {
    const value = event?.target?.value;
    setMedicineName(value);
  };

  const handleTextFieldChange = (event: any) => {
    setWeightVale({ ...weightValue, textField: event.target.value });
  };

  const handleSelectChange = (event: any, value: string | null) => {
    setWeightVale({ ...weightValue, selectField: value || "" });
  };

  const fetchCategoryData = async () => {
    try {
      const data: any = await dispatch(getCategoryData());
      const super_category = data?.payload?.category?.filter((item: any) => {
        return item?.super_category === 1;
      });
      setCategoryData(super_category);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchManufacturerNameData = async () => {
    try {
      const data: any = await dispatch(getManufacturerData());
      setManufacturerNameData(data); // Assuming getSupplierData returns the fetched data
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchManufacturerNameData();
  }, []);

  const handleSubmit = async (values: any) => {
    if (!medicineName) {
      setMedNameError("Required *");
    } else {
      setMedNameError("");
    }

    if (!categoryId) {
      setCategoryError("Required *");
    } else {
      setCategoryError("");
    }

    if (!manufacturerId) {
      setManufacturerError("Required *");
    } else {
      setManufacturerError("");
    }

    if (!categoryId || !manufacturerId) {
      return;
    }

    const pharmacyId = localStorage?.getItem("pharmacyId");
    const combinedWeightString = `${weightValue?.textField} ${weightValue?.selectField}`;

    const non_medical: any = {
      medicine_name: medicineName,
      dose: combinedWeightString,
      barcode: medBarcode,
      pharmacy_id: pharmacyId,
      category_id: categoryId,
      manufacturer_id: manufacturerId,
      super_category: 1,
    };

    !medBarcode && delete non_medical.barcode;

    try {
      const res = await dispatch(AddMedicine(non_medical));
      if (res?.payload?.success) {
        setMedicineId(res?.payload?.data?.id);
        dispatch(getNonMedicalData({ pharmacy_id: pharmacyId }));
        getMedicine();
        setOpenSnackbar();
        handleClose();
        // window.alert("Medicine added successfully!");
      } else {
        setOpenErrorToast();
        setErrorMessage(res?.payload);
        setApiError(true);
        setLoading(false); // Stop the loader
      }
    } catch (error) {
      setApiError(true);
      console.error("Error adding Product: ", error);
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  const filterOptions = (options: string[], { inputValue }: any) => {
    const normalizedInput = inputValue.toLowerCase();
    return options
      .filter((option) => option.toLowerCase().includes(normalizedInput))
      .sort((a, b) => {
        const aStartsWith = a.toLowerCase().startsWith(normalizedInput);
        const bStartsWith = b.toLowerCase().startsWith(normalizedInput);

        // Push items starting with input to the top
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;

        // Otherwise, keep the default order
        return a.localeCompare(b);
      });
  };

  return (
    <>
      <BarcodeReader onError={handleError} onScan={handleScan} />

      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <Box sx={{ mt: 0.5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Bar Code
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter barcode."
                  value={medBarcode}
                  onChange={handleBarChange}
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                {/* {!isEdit && errors?.batchNoError && ( */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  value={medicineName}
                  placeholder="Enter Name"
                  onChange={handleMedicineName}
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                <div
                  style={{
                    color: medNameError ? "red" : "red",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  {medNameError && (
                    // <div>Medicine with this name already exists</div>
                    <>{medNameError}</>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Brand/Manufacturer Name
                </Typography>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={
                    Array.isArray(manufacturerNameData?.payload?.manufacturer)
                      ? manufacturerNameData?.payload?.manufacturer?.map(
                          (manufacturer: any) => manufacturer?.name
                        )
                      : []
                  }
                  onChange={(event, value) => {
                    if (value) {
                      const selectedmanufacturer =
                        manufacturerNameData?.payload?.manufacturer?.find(
                          (manufacturer: any) => manufacturer?.name === value
                        );
                      setManufacturerId(selectedmanufacturer?.id);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Manufacturer"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "1px 5px !important",
                        },
                      }}
                    />
                  )}
                />
                {manufacturerError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {manufacturerError}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Weight
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={5}>
                    {/* Use TextField */}
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="weight"
                      placeholder="Enter Weight"
                      value={weightValue?.textField}
                      onChange={handleTextFieldChange}
                      inputProps={{
                        style: {
                          padding: "10px 12px",
                        },
                      }}
                    />
                    {/* Render error message if any */}
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      <ErrorMessage name="weight" component="div" />
                    </div>
                  </Grid>
                  <Grid item xs={7}>
                    {/* Use Select for units */}
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={
                        Array.isArray(units)
                          ? units?.map((unit: any) => unit?.name)
                          : []
                      }
                      filterOptions={filterOptions}
                      onChange={handleSelectChange}
                      value={weightValue?.selectField}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Unit"
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "1px 5px !important",
                            },
                          }}
                        />
                      )}
                    />
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      <ErrorMessage name="weight" component="div" />
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Category
                </Typography>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={
                    Array.isArray(categoryData)
                      ? categoryData?.map((category: any) => category?.name)
                      : []
                  }
                  onChange={(event, value) => {
                    if (value) {
                      const selectedCategory = categoryData?.find(
                        (category: any) => category?.name === value
                      );
                      setCategoryId(selectedCategory?.id);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Category"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "1px 5px !important",
                        },
                      }}
                    />
                  )}
                />
                {categoryError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {categoryError}
                  </div>
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mt: 1 }}>
            <AppButton
              variant="contained"
              color="primary"
              type="button"
              onClick={handleSubmit}
              title={
                loading ? <CircularProgress size={24} color="inherit" /> : "Add"
              }
              sx={{ float: "right" }}
              disabled={loading} // Disable button when loading
            />
          </Box>
        </Form>
      </Formik>
    </>
  );
};

export default AddNonMedicalModal;
